/**
 * Default Vault access script — standard jade-key / NFT-owner gate.
 *
 * Dynamic fields (nftid, utxokeys) are filled by buildDefaultAccessScript().
 * The JSON shape must remain identical to the historical vault.js fallback.
 */
module.exports = {
  id: 'default',
  label: 'Default',
  description: 'Standard Vault access: holder of the Vault Access Key NFT.',
  script: {
    op: 'CHECKOWNNFT',
    nftid: '',
    witness: {
      utxokey1: '',
      utxokey2: '',
      utxokey3: ''
    }
  },
  /**
   * Build the runtime default access-script object.
   * Matches the previous inline construction in vault.js exactly.
   */
  build: function build() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$nftid = _ref.nftid,
      nftid = _ref$nftid === void 0 ? '' : _ref$nftid,
      _ref$utxokey = _ref.utxokey1,
      utxokey1 = _ref$utxokey === void 0 ? '' : _ref$utxokey,
      _ref$utxokey2 = _ref.utxokey2,
      utxokey2 = _ref$utxokey2 === void 0 ? '' : _ref$utxokey2,
      _ref$utxokey3 = _ref.utxokey3,
      utxokey3 = _ref$utxokey3 === void 0 ? '' : _ref$utxokey3;
    return {
      op: 'CHECKOWNNFT',
      nftid: nftid,
      witness: {
        utxokey1: utxokey1,
        utxokey2: utxokey2,
        utxokey3: utxokey3
      }
    };
  }
};